/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
const fb = require('@/firebaseConfig.js')

export default {
  data() {
    current_user = nil,
    current_user_id = nil
  },
  signIn (email, password) {
    return axios.post('/auth/sign_in?email=' + email + '&password=' + password)
      .then(response => {
        this.current_user = response.headers['access-token']
        this.current_user_id = response.data.id
        this.client = response.headers['client']
        // alert("USERTOKEN:  " + this.current_user)
        localStorage.dataat = response.headers['access-token']
        // console.log(response.headers['access-token'])
        return response
      })
      .catch (response => {
        console.log("error sign_in")
      });
  }, 
  uploadAudio (uploadInfo, userId, durationSeconds, coverurl) {
    return axios.post('/v1/stories?created_by=' + userId, null, {
      params: {
        title: uploadInfo.title,
        location: uploadInfo.location,
        duration: durationSeconds,
        description: uploadInfo.description,
        author: uploadInfo.author,
        original: uploadInfo.original,
        language: uploadInfo.language,
        public: uploadInfo.public,
        cover: coverurl
      }
    })
    .then (response => {
      console.log('upload audio SUCCESS!!');
        return response.data
    })
    .catch (function(error) {
        console.log(error)
        response.error
    });
  },
  getCurrentUser () {
    return this.current_user
  },
  resetPassword (passwordparam, passwordConfirmation, access_token_param, uid_param, client_param) {
    axios.defaults.headers.put['access-token'] = access_token_param // for POST requests
    axios.defaults.headers.put['uid'] = uid_param// for POST requests
    axios.defaults.headers.put['client'] = client_param // for POST requests
    // alert("uid: " + uid_param)
    // alert("client: " + client_param)
    // alert("token: " + access_token_param)
    // alert("password: " + passwordparam)
    // alert("password_confirmation: " + passwordConfirmation)
    // /auth/password'

    return axios.put('/auth/password?password=' + passwordparam + '&password_confirmation=' + passwordConfirmation)
      .then(response => {
        return response.data
      })
      .catch (response => {
        console.log("error reset_password")
        alert('ERROR' + response)
      });
  },
  uploadBlueprint (blueprint, storyId) {
    return axios.post('/v1/blueprints', null, {
      params: {
        location: blueprint,
        story_id: storyId,
      }
    })
    .then (response => {
      console.log('Blueprint creation SUCCESS!!');
      return response.data
    })
    .catch (function(error) {
        console.log(error)
        response.error
    });
  },
  async getMetricts() {
    try {
      const response = await axios.get('/v1/getappmetrics')
      return response.data
    } catch (error) {
      console.log(error)
    }
  }
}


// WEBPACK FOOTER //
// ./src/services/api/Mainapi.js